import React from 'react'
import MainContent from './MainContent'
import Input from '../generic/Input'
import MultiSelect from '../generic/MultiSelect'
import FormRenderer from '../generic/FormRenderer'
import Button from '../generic/Button'
import { Box } from '../generic/Box'
import { observer, inject } from 'mobx-react'
import ProtectedComponent from '../generic/ProtectedComponent'
import Title from '../generic/Title'

const GenerateToken = inject('generateTokenStore', 'companiesStore')(observer((props) => {
  const { generateTokenStore, companiesStore } = props
  const { email, companies, name, isFetching } = generateTokenStore.state
  const generateTokenFields = [
    {
      component: Input,
      label: 'E-mail',
      type: 'email',
      name: 'email',
      id: 'generate-token-email',
      placeholder: 'E-mail',
      value: email
    },
    {
      component: MultiSelect,
      label: 'Empresas',
      placeholder: 'Selecionar empresas',
      value: companies.map(data => {
        return {value: data.id, label: data.name}
      }),
      options: companiesStore.state.companies.map(data => {
        return {value: data.id, label: data.name}
      }),
      onChange: selectedOptions => generateTokenStore.setCompanies(selectedOptions)
    },
    {
      component: Input,
      label: 'Nome',
      type: 'text',
      name: 'name',
      id: 'generate-token-name',
      placeholder: 'Nome',
      value: name
    },
    {
      component: Button,
      text: 'Gerar token',
      type: 'submit',
      onClick: (event) => generateTokenStore.generateToken(event),
      id: 'generate-token-submit',
      isLoading: isFetching,
      styleClass: 'app-main-button'
    }
  ]
  return (
    <ProtectedComponent permission='generate_token'>
      <MainContent>
        <Box>
          <Title>Gerar token</Title>
          <form>
            <FormRenderer fields={generateTokenFields} store={generateTokenStore} />
          </form>
        </Box>
      </MainContent>
    </ProtectedComponent>
  )
}))

export default GenerateToken



// WEBPACK FOOTER //
// ./src/components/dashboard/GenerateToken.js